import { render } from "./AppLabel.vue?vue&type=template&id=5379aec2&scoped=true"
import script from "./AppLabel.vue?vue&type=script&lang=js"
export * from "./AppLabel.vue?vue&type=script&lang=js"

import "./AppLabel.vue?vue&type=style&index=0&id=5379aec2&scoped=true&lang=css"

import exportComponent from "/Users/ferlando/Desktop/Baboon/baboon-pos/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5379aec2"]])

export default __exports__